/* Mint-Mov-Phone: nav cao 92, padding 6/8/30, mỗi tab min-height 56, chữ 13/550, icon 26. Chỉ hiện ở khổ điện thoại. */
.bar { display: none; }
@media (max-width: 600px) {
  .bar { position: fixed; left: 0; right: 0; bottom: 0; z-index: 20; height: 92px; padding: 6px 8px 30px; box-sizing: border-box; display: flex; background: var(--card); box-shadow: 0 -1px 0 var(--bd); }
  .tab { flex: 1; min-height: 56px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 3px; font-size: 13px; font-weight: var(--fw-label); color: var(--lb); text-decoration: none; white-space: nowrap; }
  .on { color: var(--pri); }
  .danger { color: var(--err); }
  .tab:focus-visible { outline: 2px solid var(--pri); outline-offset: -2px; border-radius: 12px; }
}
